import { render, staticRenderFns } from "./Block1Item.vue?vue&type=template&id=9942f5c8&scoped=true&"
import script from "./Block1Item.vue?vue&type=script&lang=js&"
export * from "./Block1Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9942f5c8",
  null
  
)

export default component.exports